async function fiveNinePlayTcpa (url, agentId, campaignId) {
  var callId = await fetch(`https://${url}/appsvcs/rs/svc/agents/${agentId}/interactions`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  }).then(result => {
    return result.json()
  }).then(parsedResult => {
    if (typeof parsedResult === 'undefined' || typeof parsedResult[0] === 'undefined') {
      return null
    }
    return parsedResult[0].interactionId
  })

  if (callId === null) {
    return null
  }

  var data = { campaignId: campaignId }

  return fetch(`https://${url}/appsvcs/rs/svc/agents/${agentId}/interactions/calls/${callId}/add_campaign_to_conference/`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(data)
  })
}

export default fiveNinePlayTcpa
